export enum MODES {
  week = 'weekly',
  month = 'monthly'
}
